var $ = jQuery.noConflict();

jQuery.fn.center = function() {
	var screen_w = $(window).width();
	var screen_h = $(window).height();
	this.css("position","fixed");
	this.css("left",Math.floor(screen_w / 2 - this.width() / 2)+"px");
	this.css("top",Math.floor(screen_h / 2 - this.height() / 2)+"px");
}

var did_count = false;
$(document).ready(function(){
	// Set carousel
	$(".carousel").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		autoplay: true,
		autoplaySpeed: 4500,
        arrows: false,
        dots: true,
        appendDots: '.carousel-navigation',
        dotsClass: 'flat-dots',
        adaptiveHeight: false,
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        speed: 1200,
	});

	$(".meal-carousel").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    dots: true,
                    appendDots: '.featured-meals-mobile-navigation',
                    dotsClass: 'flat-dots',
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    appendDots: '.featured-meals-mobile-navigation',
                    dotsClass: 'flat-dots',
                }
            }
        ],
	});

     $('#sponsor-carousel').each(function() {
        if ($(this).children().length <= 4) {
            $(this).children().each(function() {
                $(this).clone().appendTo($(this).parent());
            });
        }
     });

	$("#sponsor-carousel").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
		speed:1000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 855,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 690,
                settings: {
                    slidesToShow: 1,
                }
            }
        ],
	});

	// Set perfect width for menu buttons
	$("#menu-row ul li").width(Math.floor($("#menu-rows").width() / 6) - 2);

	// Start animations after div comes into view
	$("#stats-container").on("inview", function(event,isInView) {
		if (isInView) {
			stats_countup();
		}
	});
});

$(window).resize(function(){
	// Set perfect width for menu buttons
	$("#menu-row ul li").width(Math.floor($("#menu-rows").width() / 6) - 2);
});

function stats_countup() {
	if (!did_count) {
		var meals_anim = new CountUp("meals-stat",0,3);
		if (!meals_anim.error) {
			meals_anim.start();
		}
		var free_anim = new CountUp("free-stat",0,100);
		if (!free_anim.error) {
			free_anim.start();
		}
		var volunteers_anim = new CountUp("volunteers-stat",0,4200);
		if (!volunteers_anim.error) {
			volunteers_anim.start();
		}
		did_count = true;
	}
}

function swap_tab(num) {
	var i=1;
	var elementExists = document.getElementById("tab-text-"+i);
	while (elementExists) {
		$("#tab-text-"+i).css("display","none");
		$("#tab-img-"+i).css("display","none");
		$("#tab-"+i).css("border-bottom","0px");
		i++;
		var elementExists = document.getElementById("tab-text-"+i);
		if (i > 10) break;
	}
	$("#tab-text-"+num).fadeIn();
	$("#tab-img-"+num).fadeIn();
	$("#tab-"+num).css("border-bottom","2px solid #000");
}

function open_search() {
	$("body").append("<div id='lightbox-layover'>hello</div>");
	$("#lightbox-layover").css("z-index","3000");
	$("#lightbox-layover").css({opacity:0.5});
	$("#lightbox-layover").click(function(){
		close_search();
	});
	$("body").append("<div id='lightbox-search'><h4>Search Terms</h4><input type='text' name='terms' id='terms' /><br /><a href='index.php?page=search-results' id='search'>Search</a><a href='#' onclick='javascript:close_search();return false;' id='cancel'>Cancel</a></div>\n");
	$("#lightbox-search").center();
	$("#lightbox-search #terms").focus();
}

function close_search() {
	$("#lightbox-layover").remove();
	$("#lightbox-search").remove();
}

$('.accordian-title').each(function() {
    if ( $(this).hasClass('accordian-title-no-1')) {

    } else {
        $(this).next().hide();
        $(this).find('.accordian-arrow').addClass("flipped");
    }
});

$('.accordian-title').unbind().click(function() {
    toggle_accordian($(this));
});

function toggle_accordian( $elmt ) {
	$elmt.next().slideToggle(400);
	$elmt.find('.accordian-arrow').toggleClass("flipped");
}

$('.gallery-img-thumb').unbind().click(function() {
    event.preventDefault();
    gallery_img_open($(this));
});

function gallery_img_open(elmt) {
    console.log(event);
    console.log("why are you going so many times");
	$("body").append("<div id='lightbox-layover'></div>");
	$("#lightbox-layover").css("z-index","9999999");
	var img_path = $(elmt).find("img").attr("src");
	$("body").append("<div id='lightbox-gallery-img'><img src='"+img_path+"' onclick=\"javascript:close_gallery_img();return false;\" /></div>\n");
    $("#lightbox-gallery-img").css("z-index","9999999999");
    $("#lightbox-layover, #lightbox-gallery-img").click(function(){
		close_gallery_img();
	});
}

function close_gallery_img() {
	$("#lightbox-layover").fadeOut(300);
    $("#lightbox-gallery-img").fadeOut(300);
    setTimeout(function() {
        $("#lightbox-layover").remove();
        $("#lightbox-gallery-img").remove();
    }, 300);
}



// WEBPACK FOOTER //
// ./js/interface.js